import React from 'react';
import webSiteIcon from "../Images/website_icon.svg";
import wpIcon from "../Images/whatsapp_icon.svg";
import instaIcon from "../Images/instagram_icon.svg";

const CollaboratorCard = ({colItem}) => {
    return (
        <div className="md:min-h-[64vh] md:max-h-[92vh] mx-auto rounded-xl shadow-xl hover:shadow-2xl mb-8 relative">
            <div className={'p-6 max-h-52'}>
                <img src={colItem.logo} alt=""/>
            </div>
            <div className={'px-6 lg:mt-8 mt-0 mb-16'}>
                <span className={'font-bold text-2xl pr-6'}>{colItem.name}</span>
                <p className="text-base pr-3 pt-4">{colItem.description}</p>
            </div>
            <div className={'flex space-x-7 absolute bottom-4 right-6'}>
                {colItem.webpage &&
                    <a href={colItem.webpage} target="_blank">
                        <img src={webSiteIcon} alt="logo"/>
                    </a>
                }
                {colItem.whatsapp &&
                    <a href={`tel:${colItem.whatsapp}`}>
                        <img src={wpIcon} alt="logo"/>
                    </a>
                }
                {colItem.instagram &&
                    <a href={colItem.instagram} target="_blank">
                        <img src={instaIcon} alt="logo"/>
                    </a>
                }
            </div>
        </div>
    );
};

export default CollaboratorCard;
